// Marketing-package price-list helpers (Monday 13068472367; price-edit fix
// Michael Piccoli, 9 Oct 2026). State is { [itemKey]: { on, price } } where a
// price is stored the moment the agent types one.

// Keep only digits and decimal points as the agent types a price.
export const sanitizePrice = (raw) => String(raw ?? "").replace(/[^0-9.]/g, "");

// What to SHOW in an item's price box.
//
// Once the agent has touched a price it is theirs to keep, even when they clear
// it to blank: ``price`` is stored (``""`` included) the moment they type, so we
// return that. Only a price that was NEVER touched (``undefined``) falls back to
// the schema default, which is what lets a later default-price change flow
// through to untouched authorities.
//
// The previous version treated an empty string as "use the default", so
// backspacing a board price snapped it straight back to 403/461/852 and the
// agent could never set their own figure.
export function priceOf(item, state = {}) {
  const s = state[item.key] || {};
  if (s.price !== undefined) return s.price;
  return item.price == null ? "" : String(item.price);
}

export const isOn = (item, state = {}) => !!(state[item.key] || {}).on;

// Sum of the ticked items' prices.
export function checklistTotal(items, state = {}) {
  return (items || []).reduce(
    (sum, it) => sum + (isOn(it, state) ? (parseFloat(priceOf(it, state)) || 0) : 0),
    0,
  );
}
